import { render, staticRenderFns } from "./KtvSmsVerificationStatusAlert.vue?vue&type=template&id=2a14619a&scoped=true"
import script from "./KtvSmsVerificationStatusAlert.vue?vue&type=script&lang=js"
export * from "./KtvSmsVerificationStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./KtvSmsVerificationStatusAlert.vue?vue&type=style&index=0&id=2a14619a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a14619a",
  null
  
)

export default component.exports